import { render } from "./App.vue?vue&type=template&id=34ea17bc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=34ea17bc&lang=scss"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__